import { getConstantsApi } from '../../api/general';
import { errorNotification } from '../../helpers/notification';
import { ThunkAppDispatch } from '../../store';
import { setContansAction } from './action';

export const getConstantsThunk = () => (dispatch: ThunkAppDispatch) => {
  getConstantsApi()
    .then((res) => dispatch(setContansAction(res)))
    .catch(() => {
      errorNotification('General data info update has been failed');
    });
};
